import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { LifecycleintellegenceService } from "../lifecycleintellegence.service";
import * as FileSaver from "file-saver";
import { ApiInfoService } from "../../lifecycleintellegence/api-info/api-info.service";
import { environment } from "src/environments/environment.prod";

@Component({
  selector: "life-api-info",
  templateUrl: "./api-info.component.html",
  styleUrls: ["./api-info.component.scss"],
})
export class ApiInfoComponent implements OnInit {
  @Input() MolData: any;
  @Input() ActiveIngred: any;
  @Input() BrandName: any;
  @Input() NDAnumber: any;
  Molecule: boolean;
  secondSectionData: any;
  links = 'window.open("http://43.205.223.1:8000';
  DragData: any = {};
  typeArray = ["paraI", "paraII", "paraIII", "paraIV"];
  newArray = [];
  contentTableArray = [];
  popupcontents: any;
  contentPopups = "none";
  content_Details: [];
  content_value: "";
  sliceEnd = 5;
  contentKey = "";
  displaypopup = "none";
  data: [][];
  refEditData = {};
  submolecules: any[];
  subMolecule = false;
  selectedSubMolecule: any;
  searchValue = "";
  noData = false;
  showedit = false;
  tempData: any = {};
  changed_Cols: [];
  nullmessage: any = "";
  tablekeys: string[];
  tableData: any = [];
  tablevalues: any = [];
  colorcode: {};
  // #headerid/
  setWidth: any;
  objectKeys = Object.keys;
  objectValues = Object.values;
  linkURL: any;
  paramsValues: any;
  editedData: any;
  storedData: any;
  keysArray: Array<String> = [];
  keyIds: Array<String> = [];
  showCheckBox = false;
  options: any = [];
  thirdSectionData: any = {};
  fourthSectionData: any = {};
  ApiInformationData: any = {};
  FormulationData: any = {};
  CompetitiveData: any = {};
  ExecutiveData: any = {};
  activeIngredientforPI: any;

  constructor(
    private apiInfoService: ApiInfoService,
    private ref: ChangeDetectorRef,
    public toastr: ToastrService,
    private route: ActivatedRoute,
    private lifecycleservice: LifecycleintellegenceService,
    private sanitized: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.paramsValues = this.route.snapshot.queryParams;
    if (
      this.paramsValues.active_ingredient &&
      this.paramsValues.brand_name &&
      this.paramsValues.ndaValue &&
      this.paramsValues.section
    ) {
      this.getEditedChanges(
        this.paramsValues.active_ingredient,
        this.paramsValues.brand_name,
        this.paramsValues.ndaValue
      );
      this.Molecule = true;
    } else {
      this.getAPIInfo();
    }
  }

  getAPIInfo() {
    let active_ingredient = this.ActiveIngred;
    let brand_name = this.BrandName;
    let ndaValue = this.NDAnumber;
    let sectionFive = "api_information_details";
    this.linkURL = `${environment.ip}/#/lifecycleintellegence?active_ingredient=${active_ingredient}&brand_name=${brand_name}&ndaValue=${ndaValue}&section=${sectionFive}`;
    // this.linkURL = `http://3.111.249.237/#/lifecycleintellegence?active_ingredient=${active_ingredient}&brand_name=${brand_name}&ndaValue=${ndaValue}&section=${sectionFive}`;

    this.apiInfoService
      .getFifthSection(ndaValue)
      .subscribe((ApiInformation: any) => {
        this.Molecule = true;
        this.colorcode =
          ApiInformation.data["API INFORMATION"]["colorindicator"];
        this.DragData = ApiInformation.data["API INFORMATION"];
        this.tempData = ApiInformation.data["API INFORMATION"];
        this.refEditData = ApiInformation.data["API INFORMATION"];
      });
  }

  showArray(data, n2, n3, n4, n5, n6, n7) {
    this.contentPopups = "block";
    this.contentTableArray = data;
  }
  Selectparam(event) {
    let referdata: any = localStorage.getItem("molecules");
    let moleculedata: any = JSON.parse(referdata);
    let brand_name: any;
    brand_name = moleculedata["Brand Name/Proprietary Name"];
    let obj = {
      type: event.target.value,
      brand_name: moleculedata["Brand Name/Proprietary Name"],
    };
    this.lifecycleservice.addPara(obj).subscribe((res) => { });
  }

  showLess(data, n2, n3, n4, n5, n6, n7) {
    this.contentPopups = "block";
    this.tablekeys = Object.keys(data[0]);
    this.tablevalues = data;
  }

  /**
   *
   * @param InputProperty  value entered
   * @param Objectvalue     object values of the keys in an object
   * @returns
   */
  getcolorcode(InputProperty: string, Objectvalue: any): any {
    if (Objectvalue[InputProperty] !== undefined) {
      return Objectvalue[InputProperty];
    } else {
      return "";
    }
  }
  /**
   * Method to handle search
   */

  getEditedValues() {
    let referdata: any = localStorage.getItem("molecules");
    let moleculedata: any = JSON.parse(referdata);
    let active_ingredient = moleculedata["Active Ingredient"];
    let brand_name = moleculedata["Brand Name/Proprietary Name"];
    let ndaNumber = moleculedata["NDA number"];
    this.getEditedChanges(active_ingredient, brand_name, ndaNumber);
  }

  getEditedChanges(
    active_ingredient: string,
    brand_name: string,
    ndaNumber: number
  ) {
    this.apiInfoService
      .getEditedData(active_ingredient, brand_name, ndaNumber)
      .subscribe((res: any) => {
        if (this.paramsValues.section === "api_information_details") {
          this.DragData = res.previously_updated_db_data;
          this.storedData = res.data.edited_data_key_insert_to_db;
        }
      });
  }

  isChanged(key): any {
    this.keysArray = [];
    if (this.storedData) {
      Object.keys(this.storedData).map((keys) => {
        if (keys === key) {
          this.keysArray.push(keys);
        }
      });
      return this.keysArray;
    }
  }

  editbtn() {
    this.showedit = !this.showedit;
    if (this.showedit === true) {
      this.sliceEnd = 1000;
    } else {
      this.sliceEnd = 5;
    }
  }

  downloadFiles() {
    let referdata: any = localStorage.getItem("molecules");
    let moleculedata: any = JSON.parse(referdata);
    this.lifecycleservice
      .getdownloadfile({
        nda_number: moleculedata["NDA number"],
        brand_name: moleculedata["Brand Name/Proprietary Name"],
      })
      .subscribe((res) => {
        let resp = res["data"]["content"];
        let file = res["data"]["filename"];
        FileSaver.saveAs(
          `data:application/vnd.ms-excel;base64,${resp}`,
          `${file}`
        );
      });
  }

  // Hide and show checboxes
  downloadSelected() {
    this.showCheckBox = !this.showCheckBox;
  }
  // Selecting the checkbox
  selected_checbox(event: any, index: number) {
    if (!this.options.includes(event)) {
      this.options = [...this.options, event];
    } else {
      this.options = this.options.filter((item) => item !== event);
    }
  }
  // Download based on selected items
  downloadSelectedData() {
    let referdata: any = localStorage.getItem("molecules");
    let moleculedata: any = JSON.parse(referdata);
    let columns_data = this.options;
    this.lifecycleservice
      .downloadSelected({
        nda_number: moleculedata["NDA number"],
        brand_name: moleculedata["Brand Name/Proprietary Name"],
        columns_data,
      })
      .subscribe((res) => {
        let resp = res["data"]["content"];
        let file = res["data"]["filename"];
        FileSaver.saveAs(
          `data:application/vnd.ms-excel;base64,${resp}`,
          `${file}`
        );
      });
  }

  closecontentpopup() {
    // if (event === 'cancel') {

    this.content_Details = [];
    this.tableData = [];
    this.tablekeys = [];
    this.content_value = "";
    this.contentKey = "";
    this.contentPopups = "none";
    this.contentTableArray = [];
    // }
  }
  addClickEvent(event, value, key) {
    if (
      key === "Dosage and Administration" ||
      key === "Recommended dose" ||
      key === "Indications and Usage"
    ) {
      this.contentPopups = "block";
      this.content_Details = value;
      this.contentKey = key;
      this.content_value = "";
    } else if (
      key === "Variability (% ISCV)" ||
      key === "PK Linearity" ||
      key === "Food effect" ||
      key === "Pharmacology"
    ) {
      this.contentPopups = "block";
      this.content_Details = [];
      this.contentKey = key;
      this.content_value = value;
    } else {
      this.contentPopups = "none";
      this.content_Details = [];
      this.contentKey = "";
      this.content_value = "";
    }
    // if(event.type === 'mouseleave'){
    //   this.contentPopups = 'none';
    //   this.content_Details = [];
    //   this.contentKey ='';
    //   this.content_value ='';
    // }
  }

  addItems(data, n2, n3, n4, n5, n6, n7) {
    let objdata: any = this.DragData;
    let obj = {};
    let arr = [];
    let keys = Object.keys(data[0]);
    for (let i = 0; i <= keys.length - 1; i++) {
      obj[keys[i]] = "";
    }
    objdata[n7].push(obj);
    this.DragData = { ...objdata };
    this.ref.markForCheck();
  }

  addListItem(data, n4, n5, n6, n7) {
    let objdata: any = this.DragData;
    let arr = [];
    console.log("Arrayyyy", objdata[n7].push(arr));
    this.DragData = { ...objdata };
  }

  //** We can edit the data based on object,array and array of objects */
  editdata(event, arr, keys, trows, rd, Obj, index, varikey, n9, n10) {
    if (Obj !== undefined) {
      if (this.tempData[keys] && Obj.value) {
        this.tempData[keys].map((res, j) => {
          Obj.value.map((resp, j1) => {
            if (j === index && j === j1) {
              let objkey = Object.keys(Obj.value[0]);
              let uniquekey = objkey[n10];
              resp[uniquekey] = event.target.value;
            }
          });
        });
      }
    }
    if (Obj === "lItems") {
      if (Array.isArray(this.tempData[keys])) {
        this.tempData[keys].map((respp, k) => {
          if (arr) {
            arr.map((resps, p) => {
              if (p === rd) {
                if (resps === trows) {
                  arr[rd] = event.target.value;
                }
              }
            });
          } else {
          }
        });
      }
    } else if (Obj === undefined) {
      this.tempData[keys] = event.target.value;
    }
  }

  saveEdit() {
    this.sliceEnd = 5;
    this.showedit = !this.showedit;
    let referdata: any = localStorage.getItem("molecules");
    let moleculedata: any = JSON.parse(referdata);
    let editedData: any = {};
    editedData["edited_data"] = this.tempData;
    editedData["nda_number"] = moleculedata["NDA number"];
    editedData["brand_name_proprietary_name"] =
      moleculedata["Brand Name/Proprietary Name"];
    editedData["active_ingredient"] = moleculedata["Active Ingredient"];
    editedData["link"] = this.linkURL;
    this.apiInfoService
      .SendEmail(
        editedData["active_ingredient"],
        editedData["brand_name_proprietary_name"],
        editedData["nda_number"],
        editedData
      )
      .subscribe((res: any) => { });
  }

  handelAction(key, flag, i) {
    let updatedValue = {
      nda_number: this.paramsValues.ndaValue,
      field: key,
      flag,
      brand_name: this.paramsValues.brand_name,
      active_ingredient: this.paramsValues.active_ingredient,
    };
    this.apiInfoService
      .updateMoleculeData(updatedValue)
      .subscribe((res: any) => {
        if (flag === "accept") {
          this.keyIds.push(key.key);
          document.getElementById(key.key).style.display = "none";
          this.toastr.success("Data updated sucessfully", "");
        } else {
          this.DragData = res.old_data_with_updated_set;
          this.keyIds.push(key.key);
          setTimeout(() => {
            this.keyIds.forEach((id: String) => {
              document.getElementById(`${id}`).style.display = "none";
            });
          }, 0);
          this.toastr.error("Data rejected sucessfully", "");
        }
      });
  }

  openPdf(value) {
    let url: any = window.open(`https://oneclickfolio.com/pm_backend/${value}`);
    return this.sanitized.bypassSecurityTrustHtml(url);
  }
}
